import { render, staticRenderFns } from "./MyAccountForm.vue?vue&type=template&id=00ef48c0&"
import script from "./MyAccountForm.vue?vue&type=script&lang=js&"
export * from "./MyAccountForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports